// Client V2 common imports
const {
  ARTICLE_ADDED_TO_COLLECTION,
  ARTICLE_REMOVED_FROM_COLLECTION
} = require('client-v2/common/models/article/actions')
// Model imports
const {
  COLLECTION_EDITED,
  COLLECTION_FOLLOWING_CHANGE_PENDING,
  COLLECTION_FOLLOWING_CHANGE
} = require('./actions')
const CollectionModelRecord = require('./record')

// eslint-disable-next-line complexity
function collectionReducer(state, { type, payload }) {
  // Sanity check
  if (!payload || !(state instanceof CollectionModelRecord)) {
    return state
  }
  // Ignore actions that don't refer to this collection
  if (payload.collectionId !== state.id) {
    return state
  }
  switch (type) {
    case ARTICLE_ADDED_TO_COLLECTION:
      return state.merge({
        'posts_count': state['posts_count'] + 1
      })
    case ARTICLE_REMOVED_FROM_COLLECTION:
      return state.merge({
        'posts_count': state['posts_count'] - 1
      })
    case COLLECTION_FOLLOWING_CHANGE: {
      const countDiff = followerCountDiff(payload)
      return state.merge({
        'follower_count': state['follower_count'] + countDiff,
        isFollowing: payload.isFollowing
      })
    }
    case COLLECTION_EDITED:
      return state.merge(payload.collection)
    default:
      return state
  }
}

module.exports = collectionReducer

function followerCountDiff({ isFollowing }) {
  if (isFollowing === COLLECTION_FOLLOWING_CHANGE_PENDING) {
    return 0
  }
  return isFollowing ? +1 : -1
}
